import { SystemContextProvider } from "./index.mjs";
import { z } from "zod";
import { Implements, Injectable, Service, ServiceLifetime, collection, createInterfaceId } from "@gitlab/needle";
import { Logger, NullLogger, withPrefix } from "@gitlab-org/logging";
import { FileAccessService, FileNotFoundError, fsPathToUri, getMatchingWorkspaceFolders, getRelativePath, isFileSchemeUri, parseURIString, workspaceFolderPathFromUri } from "@gitlab-org/fs";
import { DuoFeature } from "@gitlab-org/duo-feature-access";
import { join } from "path";
import { createFallbackService, deepSnakeCaseKeys } from "@gitlab-org/core";
import { ConfigService } from "@gitlab-org/config";
import { getDuoConfigDir, getTrustedReadableDirectories, isContainedIn } from "@gitlab-org/ai-configuration";
import { basename, dirname, join as join$1, relative, resolve } from "node:path";
import { RepositoryDiscoveryService } from "@gitlab-org/repositories";
import { readFile, readdir, realpath, stat } from "node:fs/promises";
import { homedir } from "node:os";
import { parse } from "yaml";
import * as fs from "fs";
import { execSync } from "node:child_process";
//#region src/node/providers/base_os.ts
var BaseOSContextProvider = class {
	constructor(logger, loggerPrefix) {
		this.logger = withPrefix(logger, loggerPrefix);
	}
	detectOSInfo() {
		try {
			const { platform, arch: architecture } = process;
			if (!platform || !architecture) {
				this.logger.debug("Platform or architecture not available");
				return null;
			}
			return {
				platform,
				architecture
			};
		} catch (error) {
			this.logger.warn("Error detecting OS information", error);
			return null;
		}
	}
	buildOSInfoContent(osInfo) {
		const lines = [];
		lines.push(`Platform: ${this.formatPlatform(osInfo.platform)}`);
		lines.push(`Architecture: ${osInfo.architecture}`);
		return lines.join(" • ");
	}
	formatPlatform(platform) {
		return {
			win32: "Windows",
			darwin: "macOS",
			linux: "Linux",
			freebsd: "FreeBSD",
			openbsd: "OpenBSD",
			netbsd: "NetBSD",
			aix: "AIX",
			sunos: "SunOS",
			android: "Android"
		}[platform] || platform;
	}
};
//#endregion
//#region src/node/providers/os.ts
let _initClass$7;
function _applyDecs$7(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$7(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$7(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$7(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$7(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$7(t) {
	var i = _toPrimitive$7(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$7(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$7(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$7(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _DefaultOSContextProv;
(class extends BaseOSContextProvider {
	static {
		[_DefaultOSContextProv, _initClass$7] = _applyDecs$7(this, [Injectable(SystemContextProvider, [Logger])], [], 0, void 0, BaseOSContextProvider).c;
	}
	constructor(logger) {
		super(logger, "[OSContextProvider]");
	}
	async getItems() {
		try {
			const osInfo = this.detectOSInfo();
			if (!osInfo) {
				this.logger.info("No OS information detected");
				return [];
			}
			return [{
				category: "agent_user_environment",
				content: JSON.stringify(osInfo),
				id: "agent_user_environment_os_info",
				metadata: {
					title: "Operating System",
					enabled: true,
					subType: "os",
					icon: "monitor",
					secondaryText: this.buildOSInfoContent(osInfo),
					subTypeLabel: "System Information"
				}
			}];
		} catch (error) {
			this.logger.warn("Could not detect OS information", error);
			return [];
		}
	}
	static {
		_initClass$7();
	}
});
//#endregion
//#region src/node/providers/agents_md_resolver.ts
let _initClass$6;
function _applyDecs$6(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$6(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$6(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$6(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$6(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$6(t) {
	var i = _toPrimitive$6(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$6(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$6(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$6(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
/**
* Resolves and loads AGENTS.md files from user config directories and workspace folders.
*/
const AgentsMdResolver = createInterfaceId("AgentsMdResolver");
let _DefaultAgentsMdResol;
(class {
	static {
		[_DefaultAgentsMdResol, _initClass$6] = _applyDecs$6(this, [Injectable(AgentsMdResolver, [
			Logger,
			RepositoryDiscoveryService,
			collection(FileAccessService),
			ConfigService
		])], []).c;
	}
	#logger;
	#repositoryDiscoveryService;
	#fileAccessService;
	#configService;
	constructor(logger, repositoryDiscoveryService, fileAccessServices, configService) {
		this.#logger = withPrefix(logger, "[AgentsMdResolver]");
		this.#repositoryDiscoveryService = repositoryDiscoveryService;
		this.#fileAccessService = createFallbackService(new NullLogger(), fileAccessServices);
		this.#configService = configService;
	}
	async hasWorkspaceAgentsMd() {
		const config = this.#configService.get();
		return (await this.#findAllAgentsMdFiles(config.workspaceFolders || [])).length > 0;
	}
	/**
	* Resolves AGENTS.md files from user config and workspaces, returning a formatted context item.
	*/
	async resolveAgentsMdContextItem() {
		const config = this.#configService.get();
		const { cwd } = config;
		const workspaceFolders = config.workspaceFolders || [];
		const userConfigDir = process.env.GLAB_CONFIG_DIR || getDuoConfigDir();
		const allAgentsMdFiles = await this.#findAllAgentsMdFiles(workspaceFolders);
		const resolvedAgentsMds = [];
		if (userConfigDir) {
			const globalAgentsMd = await this.#resolveUserAgentsMdFile(userConfigDir, allAgentsMdFiles);
			if (globalAgentsMd) resolvedAgentsMds.push(globalAgentsMd);
		}
		const workspaceAgentsMds = await this.#resolveWorkspaceAgentsMdFiles(cwd, workspaceFolders, allAgentsMdFiles);
		resolvedAgentsMds.push(...workspaceAgentsMds);
		const additionalPaths = allAgentsMdFiles.map((fileInfo) => ({
			uriPath: fileInfo.uriPath,
			displayPath: fileInfo.workspaceRelativePath
		})).filter((file) => !resolvedAgentsMds.some((resolved) => resolved.uriPath === file.uriPath));
		return this.#formatAgentsMdContextItem(resolvedAgentsMds, additionalPaths);
	}
	/**
	* Attempts to read an AGENTS.md file, returning null if not found or empty or on error.
	*/
	async #tryReadAgentsMd(filePath, allAgentsMdFiles) {
		try {
			const ruleContent = await this.#fileAccessService.getText(filePath);
			this.#logger.info(`AGENTS.md loaded from "${filePath}"`);
			const uriPath = fsPathToUri(filePath).toString();
			return {
				uriPath,
				displayPath: allAgentsMdFiles.find((info) => info.uriPath === uriPath)?.workspaceRelativePath || filePath,
				content: ruleContent
			};
		} catch (error) {
			if (error instanceof FileNotFoundError) this.#logger.debug(`AGENTS.md file not found at "${filePath}".`);
			else this.#logger.warn(`Could not read AGENTS.md rule file from "${filePath}"`, error);
			return null;
		}
	}
	/**
	* Finds the closest AGENTS.md file to a directory by searching upward in the directory tree.
	*/
	async #findClosestAgentsMd(directoryPath, workspaceRootPath, allAgentsMdFiles) {
		const normalizedDir = resolve(directoryPath);
		const normalizedRoot = resolve(workspaceRootPath);
		const candidateFiles = allAgentsMdFiles.map((fileInfo) => ({
			...fileInfo,
			resolvedPath: resolve(fileInfo.absolutePath)
		})).filter(({ resolvedPath }) => {
			const fileDir = dirname(resolvedPath);
			if (relative(normalizedRoot, fileDir).startsWith("..")) return false;
			const relativeDirFromFile = relative(fileDir, normalizedDir);
			if (relativeDirFromFile.startsWith("..") && relativeDirFromFile !== "") return false;
			return true;
		}).sort((a, b) => {
			const depthA = a.resolvedPath.split("/").length;
			return b.resolvedPath.split("/").length - depthA;
		});
		if (candidateFiles.length === 0) return null;
		const closestFile = candidateFiles[0];
		return this.#tryReadAgentsMd(closestFile.absolutePath, allAgentsMdFiles);
	}
	/**
	* Resolves AGENTS.md files from workspace folders, finding the most specific file based on cwd.
	*/
	async #resolveWorkspaceAgentsMdFiles(cwd, workspaceFolders, allAgentsMdFiles) {
		if (!cwd) {
			const agentsMds = workspaceFolders.map((wsf) => {
				const filePath = join$1(parseURIString(wsf.uri).fsPath, "AGENTS.md");
				return this.#tryReadAgentsMd(filePath, allAgentsMdFiles);
			});
			return (await Promise.all(agentsMds)).filter((file) => file !== null);
		}
		const exactWorkspaceMatch = workspaceFolders.find((wsf) => wsf.uri === cwd);
		if (exactWorkspaceMatch) {
			const filePath = join$1(parseURIString(exactWorkspaceMatch.uri).fsPath, "AGENTS.md");
			const resolved = await this.#tryReadAgentsMd(filePath, allAgentsMdFiles);
			return resolved ? [resolved] : [];
		}
		const matchingWorkspaces = getMatchingWorkspaceFolders(cwd, workspaceFolders);
		if (!matchingWorkspaces || !matchingWorkspaces.length) {
			this.#logger.error(`"cwd" appears to not be within a workspaceFolder. This should not happen! ${JSON.stringify({
				cwd,
				workspaceFolders
			})}`);
			return [];
		}
		const agentsMds = workspaceFolders.map(async (wsf) => {
			return this.#findClosestAgentsMd(parseURIString(cwd).fsPath, parseURIString(wsf.uri).fsPath, allAgentsMdFiles);
		});
		return (await Promise.all(agentsMds)).filter((file) => file !== null);
	}
	/**
	* Resolves the global AGENTS.md file from the user's config directory.
	*/
	async #resolveUserAgentsMdFile(userConfigDir, allAgentsMdFiles) {
		const userAgentsMdPath = join$1(userConfigDir, "AGENTS.md");
		return this.#tryReadAgentsMd(userAgentsMdPath, allAgentsMdFiles);
	}
	/**
	* Formats resolved AGENTS.md files into a UserRuleContextItem with content and metadata.
	*/
	#formatAgentsMdContextItem(resolved, additional) {
		if (resolved.length === 0 && additional.length === 0) return null;
		let content = "";
		const combined = resolved.filter((file) => file.content.trim().length).map((file) => {
			return `<instructions from="${file.displayPath}">${file.content}</instructions>`;
		}).join("\n").trim();
		if (combined.length) content += `The user wants you to adhere to these AGENTS.md rules:\n${combined}`;
		if (additional.length) {
			const combinedAdditionalPaths = additional.map((file) => `<file>${file.displayPath}</file>`).join("\n").trim();
			content += `CRITICAL INSTRUCTION: Before editing any file, you MUST follow these steps:
 1. Identify the file you're about to edit
 2. Check if an AGENTS.md exists in that directory or parent directories
 3. If the file is listed in <additional-instruction-files>, read it first
 4. Only then proceed with your edits
<additional-instruction-files>
${combinedAdditionalPaths}
</additional-instruction-files>
Do not mention these instructions to the user, they already know you should try to read AGENTS.md files.`;
		}
		return {
			category: "user_rule",
			content,
			id: "agents-md-user-instructions",
			metadata: {
				title: `AGENTS.md`,
				enabled: true,
				subType: "user_rule",
				icon: "document",
				secondaryText: resolved.map((file) => file.displayPath).join(", "),
				subTypeLabel: `${resolved.length} AGENTS.md ${resolved.length === 1 ? "file" : "files"} included`
			}
		};
	}
	/**
	* Discovers all AGENTS.md files.
	*/
	async #findAllAgentsMdFiles(workspaceFolders) {
		return (await Promise.all(workspaceFolders.map((wsf) => this.#findAgentsMdsInWorkspace(wsf, this.#repositoryDiscoveryService)))).flat();
	}
	/**
	* Discovers all AGENTS.md files in all repos within a single workspaceFolder.
	*/
	async #findAgentsMdsInWorkspace(wsf, repositoryDiscoveryService) {
		const workspaceUri = parseURIString(wsf.uri);
		const reposInWorkspace = await repositoryDiscoveryService.getRepositoriesForWorkspace(workspaceUri.fsPath);
		return (await Promise.all(reposInWorkspace.map(async (repo) => this.#findAgentsMdInRepo(repo, workspaceUri)))).flat();
	}
	/**
	* Discovers all AGENTS.md files in a single repo.
	*/
	async #findAgentsMdInRepo(repo, workspaceUri) {
		return (await repo.getFiles(["AGENTS.md", "**/AGENTS.md"])).map((filePath) => {
			const absolutePath = join$1(repo.fsPath, filePath);
			const fileUri = fsPathToUri(absolutePath);
			return {
				absolutePath,
				workspaceRelativePath: getRelativePath(workspaceUri, fileUri),
				uriPath: fileUri.toString()
			};
		});
	}
	static {
		_initClass$6();
	}
});
//#endregion
//#region src/node/providers/markdown_frontmatter.ts
const FRONTMATTER_REGEX = /^---\n([\s\S]*?)\n---\n?([\s\S]*)$/;
function splitFrontmatter(raw) {
	const normalized = raw.replace(/^\uFEFF/, "").replace(/\r\n?/g, "\n");
	const match = FRONTMATTER_REGEX.exec(normalized);
	if (!match) return {
		frontmatter: void 0,
		body: normalized.trim()
	};
	return {
		frontmatter: match[1],
		body: match[2].trim()
	};
}
//#endregion
//#region src/node/providers/plugin_skills_source.ts
/** A SKILL.md contributed by an installed plugin. */
/**
* Port for discovering skill files contributed by installed plugins. ai-context owns this
* interface but has no dependency on the plugin marketplace package; a client that has a
* marketplace (e.g. the CLI) registers that implementation, while other clients register
* `NoopPluginSkillsSource`.
*
* Implementations are responsible for path safety: returned `skillFilePath`s must already
* be confined to a location the implementation trusts. The resolver treats them like global
* skill paths and re-checks containment against `getTrustedReadableDirectories()` at read time.
*/
const PluginSkillsSource = createInterfaceId("AiContextPluginSkillsSource");
//#endregion
//#region src/node/providers/agent_skills_resolver.ts
let _initClass$5;
function _applyDecs$5(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$5(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$5(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$5(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$5(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$5(t) {
	var i = _toPrimitive$5(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$5(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$5(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$5(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const AgentSkillsResolver = createInterfaceId("AgentSkillsResolver");
const SKILL_GLOB = [
	".agents/skills/*/SKILL.md",
	"**/.agents/skills/*/SKILL.md",
	"skills/*/SKILL.md",
	"**/skills/*/SKILL.md"
];
const NESTED_SKILL_GLOB = SKILL_GLOB.filter((glob) => glob.startsWith("**/"));
const TOP_LEVEL_SKILL_DIR_SEGMENTS = [[".agents", "skills"], ["skills"]];
function makeGlobalDisplayPath(absolutePath) {
	try {
		const home = homedir();
		if (absolutePath.startsWith(home) && (absolutePath.length === home.length || absolutePath[home.length] === "/")) return `~${absolutePath.slice(home.length)}`;
	} catch {}
	return absolutePath;
}
const SkillFrontmatterSchema = z.object({
	name: z.string(),
	description: z.string(),
	metadata: z.object({ "slash-command": z.union([z.boolean(), z.string().transform((val) => val === "enabled" || val === "true")]).optional() }).optional()
});
function describeInvalidFrontmatter(parsed, error) {
	const obj = typeof parsed === "object" && parsed !== null ? parsed : {};
	const missing = ["name", "description"].filter((field) => obj[field] === void 0);
	if (missing.length > 0) return `is missing required frontmatter field(s): ${missing.join(", ")}`;
	const issue = error.issues[0];
	return `has an invalid "${issue.path.length > 0 ? issue.path.join(".") : "frontmatter"}" field — it must be text (quote values that contain ":" or other special characters)`;
}
let _DefaultAgentSkillsRe;
(class {
	static {
		[_DefaultAgentSkillsRe, _initClass$5] = _applyDecs$5(this, [Injectable(AgentSkillsResolver, [
			Logger,
			RepositoryDiscoveryService,
			collection(FileAccessService),
			ConfigService,
			PluginSkillsSource
		])], []).c;
	}
	#logger;
	#repositoryDiscoveryService;
	#fileAccessService;
	#configService;
	#pluginSkillsSource;
	constructor(logger, repositoryDiscoveryService, fileAccessServices, configService, pluginSkillsSource) {
		this.#logger = withPrefix(logger, "[AgentSkillsResolver]");
		this.#repositoryDiscoveryService = repositoryDiscoveryService;
		this.#fileAccessService = createFallbackService(new NullLogger(), fileAccessServices);
		this.#configService = configService;
		this.#pluginSkillsSource = pluginSkillsSource;
	}
	async resolveAgentSkillsContextItem() {
		const repoCache = /* @__PURE__ */ new Map();
		const { skills } = await this.#resolveAllSkills(repoCache);
		if (skills.length === 0) return this.#formatEmptyContextItem(await this.#getSearchedLocations(repoCache));
		return this.#formatSkillsContextItem(skills);
	}
	async getSkillSlashCommands() {
		const { skills, warnings, conflicts } = await this.#resolveAllSkills();
		return {
			commands: skills.filter((skill) => skill.slashCommand).map((skill) => ({
				name: `/${skill.name}`,
				description: skill.description,
				skillName: skill.name
			})),
			warnings,
			conflicts
		};
	}
	async getSkills() {
		const { skills } = await this.#resolveAllSkills();
		return skills.map((skill) => ({
			name: skill.name,
			description: skill.description
		}));
	}
	async #resolveAllSkills(repoCache) {
		const warnings = [];
		const workspaceFolders = this.#configService.get().workspaceFolders || [];
		const allSkillFiles = await this.#findAllSkillFiles(workspaceFolders, repoCache);
		const uniqueSkills = /* @__PURE__ */ new Map();
		const conflicts = /* @__PURE__ */ new Map();
		if (allSkillFiles.length > 0) {
			const allSkills = await this.#resolveSkillFiles(allSkillFiles, warnings);
			for (const skill of allSkills) {
				const existing = uniqueSkills.get(skill.name);
				if (!existing) uniqueSkills.set(skill.name, skill);
				else {
					this.#logger.debug(`Skipping duplicate skill "${skill.name}" from "${skill.displayPath}"`);
					this.#recordConflict(conflicts, existing, skill);
				}
			}
		}
		return {
			skills: [...uniqueSkills.values()],
			warnings,
			conflicts: [...conflicts.values()]
		};
	}
	#recordConflict(conflicts, winner, loser) {
		const toEntry = (skill) => ({
			displayPath: skill.displayPath,
			source: skill.source
		});
		const existing = conflicts.get(winner.name);
		if (existing) existing.losers.push(toEntry(loser));
		else conflicts.set(winner.name, {
			skillName: winner.name,
			winner: toEntry(winner),
			losers: [toEntry(loser)]
		});
	}
	async #resolveSkillFiles(skillFiles, warnings) {
		return (await Promise.all(skillFiles.map((fileInfo) => this.#tryReadSkillFile(fileInfo, warnings)))).filter((skill) => skill !== null);
	}
	async #tryReadSkillFile(fileInfo, warnings) {
		try {
			let readPath = fileInfo.absolutePath;
			if (fileInfo.trustedRoots) {
				const realPath = await this.#fileAccessService.realPath(fileInfo.absolutePath);
				if (!realPath || !isContainedIn(fileInfo.trustedRoots, realPath)) {
					this.#logger.warn(`Skipping skill "${fileInfo.absolutePath}": resolves to "${realPath}" outside trusted directories`);
					return null;
				}
				readPath = realPath;
			}
			const rawContent = await this.#fileAccessService.getText(readPath);
			const parsed = _DefaultAgentSkillsRe.parseFrontmatterResult(rawContent);
			if (!parsed.ok) {
				this.#logger.warn(`SKILL.md at "${fileInfo.absolutePath}" ${parsed.reason}, skipping`);
				warnings.push({
					path: fileInfo.absolutePath,
					reason: parsed.reason
				});
				return null;
			}
			this.#logger.info(`SKILL.md loaded from "${fileInfo.absolutePath}"`);
			return {
				name: fileInfo.pluginName ? `${fileInfo.pluginName}:${parsed.value.name}` : parsed.value.name,
				description: parsed.value.description,
				displayPath: fileInfo.workspaceRelativePath,
				location: fileInfo.absolutePath,
				slashCommand: parsed.value.slashCommand,
				source: fileInfo.source
			};
		} catch (error) {
			if (error instanceof FileNotFoundError) this.#logger.debug(`SKILL.md file not found at "${fileInfo.absolutePath}".`);
			else this.#logger.warn(`Could not read SKILL.md from "${fileInfo.absolutePath}"`, error);
			return null;
		}
	}
	static parseFrontmatterResult(raw) {
		const { frontmatter, body } = splitFrontmatter(raw);
		if (frontmatter === void 0) return {
			ok: false,
			reason: "is missing YAML frontmatter (no \"---\" delimited block at the top of the file)"
		};
		let parsed;
		try {
			parsed = parse(frontmatter);
		} catch (error) {
			return {
				ok: false,
				reason: `has invalid YAML frontmatter: ${error instanceof Error ? error.message : String(error)}`
			};
		}
		const result = SkillFrontmatterSchema.safeParse(parsed);
		if (!result.success) return {
			ok: false,
			reason: describeInvalidFrontmatter(parsed, result.error)
		};
		return {
			ok: true,
			value: {
				name: result.data.name,
				description: result.data.description,
				body,
				slashCommand: result.data.metadata?.["slash-command"] === true
			}
		};
	}
	#formatEmptyContextItem(locations) {
		return {
			category: "user_rule",
			content: locations.length > 0 ? `No agent skills were discovered. Searched the following locations:\n${locations.map((loc) => `  ${loc}`).join("\n")}` : "No agent skills were discovered (no skill locations were configured).",
			id: "agent-skills-instructions",
			metadata: {
				title: "Agent Skills",
				enabled: true,
				subType: "user_rule",
				icon: "document",
				secondaryText: "",
				subTypeLabel: "No agent skills found"
			}
		};
	}
	#formatSkillsContextItem(skills) {
		return {
			category: "user_rule",
			content: `The following agent skills are available in this workspace. Load the skill file when a task matches one of the available skills listed below:\n\n<available_skills>\n${skills.map((skill) => `  <skill>\n    <name>${skill.name}</name>\n    <description>${skill.description}</description>\n    <location>${skill.location}</location>\n  </skill>`).join("\n")}\n</available_skills>`,
			id: "agent-skills-instructions",
			metadata: {
				title: "Agent Skills",
				enabled: true,
				subType: "user_rule",
				icon: "document",
				secondaryText: skills.map((s) => s.name).join(", "),
				subTypeLabel: `${skills.length} agent ${skills.length === 1 ? "skill" : "skills"} included`
			}
		};
	}
	#getGlobalSkillDirectories() {
		return getTrustedReadableDirectories().map((dir) => join$1(dir, "skills"));
	}
	async #getSearchedLocations(repoCache) {
		const fileSchemeWorkspaceFolders = (this.#configService.get().workspaceFolders || []).filter((wsf) => isFileSchemeUri(wsf.uri));
		const workspaceLocationSets = await Promise.all(fileSchemeWorkspaceFolders.map((wsf) => this.#getWorkspaceSearchedLocations(wsf, repoCache)));
		const locations = new Set(workspaceLocationSets.flat());
		for (const dir of this.#getGlobalSkillDirectories()) locations.add(`${makeGlobalDisplayPath(dir)}/*/`);
		if (this.#pluginSkillsSource.contributesSkills) locations.add("installed plugins");
		return [...locations];
	}
	async #getWorkspaceSearchedLocations(wsf, repoCache) {
		const workspaceUri = parseURIString(wsf.uri);
		return (await this.#getReposForWorkspace(workspaceUri.fsPath, repoCache)).flatMap((repo) => SKILL_GLOB.map((glob) => {
			const dirGlob = glob.replace(/\/SKILL\.md$/, "");
			return `${getRelativePath(workspaceUri, fsPathToUri(join$1(repo.fsPath, dirGlob)))}/`;
		}));
	}
	async #getReposForWorkspace(workspaceFsPath, repoCache) {
		if (repoCache) {
			const cached = repoCache.get(workspaceFsPath);
			if (cached) return cached;
		}
		const repos = await this.#repositoryDiscoveryService.getRepositoriesForWorkspace(workspaceFsPath);
		repoCache?.set(workspaceFsPath, repos);
		return repos;
	}
	async #findGlobalSkillFiles() {
		const trustedDirs = getTrustedReadableDirectories().map((dir) => resolve(dir));
		const globalDirs = trustedDirs.map((dir) => join$1(dir, "skills"));
		const canonicalTrustedDirs = await this.#getCanonicalTrustedDirs(trustedDirs);
		return (await Promise.all(globalDirs.map((baseDir) => this.#findSkillsInGlobalDir(baseDir, canonicalTrustedDirs)))).flat();
	}
	async #getCanonicalTrustedDirs(trustedDirs) {
		return Promise.all(trustedDirs.map(async (dir) => await this.#fileAccessService.realPath(dir) || dir));
	}
	async #findPluginSkillFiles(workspaceFolders) {
		const workspacePaths = workspaceFolders.filter((wsf) => isFileSchemeUri(wsf.uri)).map((wsf) => parseURIString(wsf.uri).fsPath);
		let files;
		try {
			files = await this.#pluginSkillsSource.listSkillFiles(workspacePaths);
		} catch (error) {
			this.#logger.warn("Could not list skill files from the plugin skills source", error);
			return [];
		}
		if (files.length === 0) return [];
		const trustedDirs = getTrustedReadableDirectories().map((dir) => resolve(dir));
		const canonicalTrustedDirs = await this.#getCanonicalTrustedDirs(trustedDirs);
		return files.map((file) => ({
			absolutePath: file.skillFilePath,
			workspaceRelativePath: file.displayPath,
			skillDir: dirname(file.skillFilePath),
			source: "plugin",
			pluginName: file.pluginName,
			trustedRoots: canonicalTrustedDirs
		}));
	}
	async #listSkillDirEntries(baseDir, trustedRoots) {
		const entries = await readdir(baseDir, { withFileTypes: true });
		return (await Promise.all(entries.map(async (entry) => {
			if (entry.isDirectory()) return entry.name;
			if (!entry.isSymbolicLink()) return void 0;
			const linkPath = join$1(baseDir, entry.name);
			try {
				if (!(await stat(linkPath)).isDirectory()) return void 0;
				if (trustedRoots) {
					const realPath = await this.#fileAccessService.realPath(linkPath);
					if (!realPath || !isContainedIn(trustedRoots, realPath)) {
						this.#logger.warn(`Skipping skill symlink "${linkPath}": target "${realPath}" is outside trusted directories`);
						return;
					}
				}
				return entry.name;
			} catch (err) {
				this.#logFsDiscoveryError(`symlink target "${linkPath}"`, err);
				return;
			}
		}))).filter((name) => name !== void 0);
	}
	async #findSkillsInGlobalDir(baseDir, canonicalTrustedDirs) {
		try {
			return (await this.#listSkillDirEntries(baseDir, canonicalTrustedDirs)).map((name) => {
				const skillDirPath = join$1(baseDir, name);
				const skillFilePath = join$1(skillDirPath, "SKILL.md");
				return {
					absolutePath: skillFilePath,
					workspaceRelativePath: makeGlobalDisplayPath(skillFilePath),
					skillDir: skillDirPath,
					source: "global",
					trustedRoots: canonicalTrustedDirs
				};
			});
		} catch (error) {
			if (error instanceof Error && "code" in error && error.code === "ENOENT") this.#logger.debug(`Global skills directory not found: "${baseDir}"`);
			else this.#logger.warn(`Could not read global skills directory: "${baseDir}"`, error);
			return [];
		}
	}
	async #findAllSkillFiles(workspaceFolders, repoCache) {
		const [workspaceResults, globalResults, pluginResults] = await Promise.all([
			Promise.all(workspaceFolders.map((wsf) => this.#findSkillsInWorkspace(wsf, repoCache))),
			this.#findGlobalSkillFiles(),
			this.#findPluginSkillFiles(workspaceFolders)
		]);
		return [
			...workspaceResults.flat(),
			...globalResults,
			...pluginResults
		];
	}
	async #findSkillsInWorkspace(wsf, repoCache) {
		if (!isFileSchemeUri(wsf.uri)) {
			this.#logger.debug(`Skipping skill discovery for virtual workspace: ${wsf.uri}`);
			return [];
		}
		const workspaceUri = parseURIString(wsf.uri);
		const reposInWorkspace = await this.#getReposForWorkspace(workspaceUri.fsPath, repoCache);
		return (await Promise.all(reposInWorkspace.map((repo) => this.#findSkillsInRepo(repo, workspaceUri)))).flat();
	}
	async #findSkillsInRepo(repo, workspaceUri) {
		const topLevelBaseDirs = await this.#resolveTopLevelBaseDirs(repo.fsPath);
		const topLevelResults = await Promise.all(topLevelBaseDirs.map((baseDir) => this.#findSkillsInWorkspaceBaseDir(baseDir, workspaceUri)));
		const nestedFiles = await repo.getFiles(NESTED_SKILL_GLOB);
		const gitSkillFiles = nestedFiles.map((filePath) => {
			const absolutePath = join$1(repo.fsPath, filePath);
			return {
				absolutePath,
				workspaceRelativePath: getRelativePath(workspaceUri, fsPathToUri(absolutePath)),
				skillDir: join$1(repo.fsPath, filePath, ".."),
				source: "workspace"
			};
		});
		const symlinkSkillFiles = await this.#findSymlinkedSkillsInNestedDirs(repo, workspaceUri, nestedFiles);
		return this.#dedupeByCanonicalPath([
			...topLevelResults.flat(),
			...gitSkillFiles,
			...symlinkSkillFiles
		]);
	}
	async #dedupeByCanonicalPath(skillFiles) {
		const canonicalPaths = await Promise.all(skillFiles.map(async (skillFile) => await this.#fileAccessService.realPath(skillFile.absolutePath) || skillFile.absolutePath));
		const seen = /* @__PURE__ */ new Set();
		return skillFiles.filter((_, index) => {
			const canonical = canonicalPaths[index];
			const isFirstSeen = !seen.has(canonical);
			seen.add(canonical);
			return isFirstSeen;
		});
	}
	async #resolveTopLevelBaseDirs(repoFsPath) {
		const baseDirs = TOP_LEVEL_SKILL_DIR_SEGMENTS.map((segments) => join$1(repoFsPath, ...segments));
		const canonicalTargets = await Promise.all(baseDirs.map(async (baseDir) => await this.#fileAccessService.realPath(baseDir) || baseDir));
		const seen = /* @__PURE__ */ new Set();
		return baseDirs.filter((_, index) => {
			const canonical = canonicalTargets[index];
			const isFirstSeen = !seen.has(canonical);
			seen.add(canonical);
			return isFirstSeen;
		});
	}
	async #findSkillsInWorkspaceBaseDir(baseDir, workspaceUri) {
		try {
			return (await this.#listSkillDirEntries(baseDir)).map((name) => {
				const skillDir = join$1(baseDir, name);
				const absolutePath = join$1(skillDir, "SKILL.md");
				return {
					absolutePath,
					workspaceRelativePath: getRelativePath(workspaceUri, fsPathToUri(absolutePath)),
					skillDir,
					source: "workspace"
				};
			});
		} catch (error) {
			this.#logFsDiscoveryError(`skill base directory "${baseDir}"`, error);
			return [];
		}
	}
	async #findSymlinkedSkillsInNestedDirs(repo, workspaceUri, gitSkillFiles) {
		const baseDirs = /* @__PURE__ */ new Set();
		for (const filePath of gitSkillFiles) baseDirs.add(dirname(dirname(join$1(repo.fsPath, filePath))));
		return (await Promise.all([...baseDirs].map((baseDir) => this.#findSymlinkedSkillsInDir(baseDir, workspaceUri)))).flat();
	}
	async #findSymlinkedSkillsInDir(baseDir, workspaceUri) {
		let entries;
		try {
			entries = await readdir(baseDir, { withFileTypes: true });
		} catch (error) {
			this.#logFsDiscoveryError(`skill base directory "${baseDir}"`, error);
			return [];
		}
		return (await Promise.all(entries.map(async (entry) => {
			if (!entry.isSymbolicLink()) return void 0;
			try {
				return (await stat(join$1(baseDir, entry.name))).isDirectory() ? entry.name : void 0;
			} catch (statError) {
				this.#logFsDiscoveryError(`symlink target "${join$1(baseDir, entry.name)}"`, statError);
				return;
			}
		}))).filter((name) => name !== void 0).map((name) => {
			const skillDir = join$1(baseDir, name);
			const absolutePath = join$1(skillDir, "SKILL.md");
			return {
				absolutePath,
				workspaceRelativePath: getRelativePath(workspaceUri, fsPathToUri(absolutePath)),
				skillDir,
				source: "workspace"
			};
		});
	}
	#logFsDiscoveryError(subject, error) {
		if (error instanceof Error && "code" in error && error.code === "ENOENT") this.#logger.debug(`Skipping missing ${subject} during skill discovery`);
		else this.#logger.warn(`Could not read ${subject} during skill discovery`, error);
	}
	static {
		_initClass$5();
	}
});
//#endregion
//#region src/node/providers/rule.ts
let _initClass$4;
function _applyDecs$4(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$4(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$4(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$4(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$4(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$4(t) {
	var i = _toPrimitive$4(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$4(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$4(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$4(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _DefaultUserRuleConte;
(class {
	static {
		[_DefaultUserRuleConte, _initClass$4] = _applyDecs$4(this, [Injectable(SystemContextProvider, [
			Logger,
			collection(FileAccessService),
			ConfigService,
			AgentsMdResolver,
			AgentSkillsResolver
		])], []).c;
	}
	chatRequiredFeature = DuoFeature.IncludeUserRule;
	#logger;
	#fileAccessService;
	#configService;
	#cachedItems = null;
	#agentsMdResolver;
	#agentSkillsResolver;
	constructor(logger, fileAccessServices, configService, agentsMdResolver, agentSkillsResolver) {
		this.#logger = withPrefix(logger, "[UserRuleContextProvider]");
		this.#configService = configService;
		this.#fileAccessService = createFallbackService(new NullLogger(), fileAccessServices);
		this.#agentsMdResolver = agentsMdResolver;
		this.#agentSkillsResolver = agentSkillsResolver;
	}
	async precalculateOnWorkflowStart() {
		this.#cachedItems = this.#calculateItems();
		try {
			await this.#cachedItems;
			this.#logger.info("User rules context precalculated and cached");
		} catch (error) {
			this.#logger.error("Failed to precalculate user rules context", error);
		}
	}
	async getItems() {
		if (!this.#cachedItems) this.#cachedItems = this.#calculateItems();
		return this.#cachedItems;
	}
	async #readRuleFile(filePath, type) {
		const capType = `${type.charAt(0).toUpperCase()}${type.slice(1)}`;
		const metadata = {
			id: `${type}-config-rules`,
			title: `${capType} rules`,
			icon: "folder",
			secondaryText: `${capType} config chat-rules.md`,
			subTypeLabel: `${capType} rules`
		};
		const notFoundMessage = `${capType}-level Duo Chat rules file not found at ${filePath}, no user rules applied.`;
		try {
			const ruleContent = await this.#fileAccessService.getText(filePath);
			this.#logger.info(`${metadata.title} loaded from ${filePath}`);
			return {
				category: "user_rule",
				content: `The user wants you to adhere to these rules:\n${ruleContent.trim()}`,
				id: metadata.id,
				metadata: {
					title: metadata.title,
					enabled: true,
					subType: "user_rule",
					icon: metadata.icon,
					secondaryText: metadata.secondaryText,
					subTypeLabel: metadata.subTypeLabel
				}
			};
		} catch (error) {
			if (error instanceof FileNotFoundError) this.#logger.info(notFoundMessage);
			else this.#logger.warn(`Could not read ${type} rules file from ${filePath}`, error);
			return null;
		}
	}
	async #calculateItems() {
		const items = [];
		const userConfigDir = process.env.GLAB_CONFIG_DIR || getDuoConfigDir();
		if (userConfigDir) {
			const userRulePath = join(userConfigDir, "chat-rules.md");
			const userRule = await this.#readRuleFile(userRulePath, "user");
			if (userRule) items.push(userRule);
		}
		const agentsMd = await this.#agentsMdResolver.resolveAgentsMdContextItem();
		if (agentsMd) items.push(agentsMd);
		const agentSkills = await this.#agentSkillsResolver.resolveAgentSkillsContextItem();
		items.push(agentSkills);
		const workspaceFolders = this.#configService.get().workspaceFolders || [];
		if (workspaceFolders.length > 0) {
			const workspaceFolderPath = parseURIString(workspaceFolders[0].uri).fsPath;
			const workspaceRulePath = join(workspaceFolderPath, ".gitlab", "duo", "chat-rules.md");
			const workspaceRule = await this.#readRuleFile(workspaceRulePath, "workspace");
			if (workspaceRule) items.push(workspaceRule);
		}
		return items;
	}
	static {
		_initClass$4();
	}
});
//#endregion
//#region src/node/providers/shell_utils.ts
function buildShellInfoContent(shellInfo) {
	const lines = [];
	lines.push(`Shell: ${shellInfo.shellName}`);
	if (shellInfo.shellVariant) lines.push(`Variant: ${shellInfo.shellVariant}`);
	if (shellInfo.shellEnvironment && shellInfo.shellEnvironment !== "native") lines.push(`Environment: ${formatShellEnvironment(shellInfo.shellEnvironment)}`);
	if (shellInfo.sshSession) lines.push("SSH Session: Active");
	return lines.join(" • ");
}
function formatShellEnvironment(env) {
	return {
		wsl: "Windows Subsystem for Linux",
		"git-bash": "Git Bash",
		mingw: "MinGW",
		cygwin: "Cygwin",
		ssh: "SSH Session",
		docker: "Docker Container"
	}[env] || env;
}
function extractUnixShellName(output) {
	for (const shell of [
		"bash",
		"zsh",
		"fish",
		"dash",
		"tcsh",
		"ksh",
		"csh",
		"sh"
	]) if (new RegExp(`(?:^|[^a-zA-Z0-9])${shell}(?:[^a-zA-Z0-9]|$)`).test(output)) return shell;
	return null;
}
function buildShellContextItems(shellInfo) {
	const { detectionMethod, ...shellInfoContent } = shellInfo;
	const shellInfoForDWS = deepSnakeCaseKeys(shellInfoContent);
	return [{
		category: "agent_user_environment",
		content: JSON.stringify(shellInfoForDWS),
		id: "agent_user_environment_shell_info",
		metadata: {
			title: "Shell Environment",
			enabled: true,
			subType: "shell",
			icon: "terminal",
			secondaryText: buildShellInfoContent(shellInfo),
			subTypeLabel: detectionMethod === "ide-terminal" ? "IDE Terminal" : "System Terminal"
		}
	}];
}
//#endregion
//#region src/node/providers/shell_detector.ts
var ShellDetector = class {
	#logger;
	#configService;
	constructor(logger, configService) {
		this.#logger = withPrefix(logger, "[ShellDetector]");
		this.#configService = configService;
	}
	detectSystemShell() {
		try {
			return this.#detectSystemShellInternal();
		} catch (error) {
			this.#logger.warn("Could not detect shell information", error);
			return null;
		}
	}
	#detectSystemShellInternal() {
		const environment = this.detectEnvironment();
		const isSSH = this.isSSHSession();
		const cwd = this.getWorkspacePath() || void 0;
		if (environment === "wsl") return {
			...this.#detectWSLShell(isSSH),
			cwd,
			detectionMethod: "system-fallback"
		};
		if (environment === "git-bash" || environment === "mingw") return {
			shellName: "bash",
			shellType: "hybrid",
			shellVariant: "Git Bash",
			shellEnvironment: environment,
			sshSession: isSSH,
			cwd,
			detectionMethod: "system-fallback"
		};
		if (environment === "cygwin") return {
			...this.#detectCygwinShell(isSSH),
			cwd,
			detectionMethod: "system-fallback"
		};
		const { platform } = process;
		if (platform === "win32") {
			const shell = this.detectWindowsSystemShell();
			if (shell) return {
				...shell,
				shellEnvironment: "native",
				sshSession: isSSH,
				cwd,
				detectionMethod: "system-fallback"
			};
		} else if (platform === "linux" || platform === "darwin" || platform === "freebsd" || platform === "openbsd") {
			const shell = this.detectUnixSystemShell();
			if (shell) return {
				...shell,
				shellEnvironment: environment || "native",
				sshSession: isSSH,
				cwd,
				detectionMethod: "system-fallback"
			};
		}
		return null;
	}
	detectWindowsSystemShell() {
		try {
			try {
				execSync("Get-Host", {
					stdio: "pipe",
					windowsHide: true
				});
				return {
					shellName: "powershell",
					shellType: "windows",
					shellVariant: Boolean(process.env.POWERSHELL_DISTRIBUTION_CHANNEL) ? "PowerShell Core" : "Windows PowerShell"
				};
			} catch {
				const comSpec = process.env.ComSpec;
				if (comSpec?.toLowerCase().includes("cmd.exe")) return {
					shellName: "cmd",
					shellType: "windows",
					shellVariant: "Command Prompt"
				};
				if (!comSpec) return {
					shellName: "cmd",
					shellType: "windows",
					shellVariant: "Command Prompt"
				};
				return null;
			}
		} catch (error) {
			this.#logger.error("Error detecting Windows shell", error);
			return null;
		}
	}
	detectUnixSystemShell() {
		const { ppid } = process;
		if (ppid) try {
			const shellName = extractUnixShellName(execSync(`ps -p ${ppid} -o comm=`, {
				encoding: "utf8",
				stdio: "pipe"
			}).trim());
			if (shellName) return {
				shellName,
				shellType: "unix"
			};
		} catch {}
		const shellEnv = process.env.SHELL;
		if (shellEnv) {
			const shellName = extractUnixShellName(shellEnv);
			if (shellName) return {
				shellName,
				shellType: "unix"
			};
		}
		return {
			shellName: "sh",
			shellType: "unix",
			shellVariant: "POSIX shell"
		};
	}
	detectEnvironment() {
		if (process.env.WSL_DISTRO_NAME || process.env.WSL_INTEROP) return "wsl";
		if (process.env.CYGWIN || this.#isCygwin()) return "cygwin";
		if (process.env.MINGW_PREFIX || process.env.MSYSTEM) return "mingw";
		if (process.platform === "win32" && process.env.SHELL?.includes("bash")) return "git-bash";
		if (this.#isDocker()) return "docker";
		return null;
	}
	isSSHSession() {
		return Boolean(process.env.SSH_CLIENT || process.env.SSH_TTY || process.env.SSH_CONNECTION);
	}
	/**
	* Gets the workspace path from the config service, falling back to process.cwd().
	*
	* This is necessary because Node.js SEA (Single Executable Application) binaries
	* don't respect the working directory set by the parent process (e.g., via
	* Java's ProcessBuilder.directory()). The workspaceFolders are sent during
	* LSP initialization and provide the correct workspace path.
	*/
	getWorkspacePath() {
		const workspaceFolders = this.#configService.get("workspaceFolders");
		if (workspaceFolders && workspaceFolders.length > 0) {
			const firstFolder = workspaceFolders[0];
			if (isFileSchemeUri(firstFolder.uri)) try {
				return workspaceFolderPathFromUri(firstFolder.uri);
			} catch (error) {
				this.#logger.warn("Failed to parse workspace folder URI, falling back to cwd config", error);
			}
		}
		const configCwd = this.#configService.get("cwd");
		if (configCwd) return configCwd;
		try {
			return process.cwd();
		} catch (error) {
			this.#logger.error("Could not get current working directory", error);
			return "/";
		}
	}
	#detectWSLShell(isSSH) {
		return {
			...this.detectUnixSystemShell() ?? { shellName: "bash" },
			shellType: "hybrid",
			shellEnvironment: "wsl",
			shellVariant: `WSL ${process.env.WSL_DISTRO_NAME || "Unknown"}`,
			sshSession: isSSH
		};
	}
	#detectCygwinShell(isSSH) {
		const shellEnv = process.env.SHELL;
		return {
			shellName: (shellEnv ? extractUnixShellName(shellEnv) : null) || "bash",
			shellType: "hybrid",
			shellVariant: "Cygwin",
			shellEnvironment: "cygwin",
			sshSession: isSSH
		};
	}
	#isDocker() {
		try {
			if (fs.existsSync("/.dockerenv")) return true;
		} catch {}
		try {
			return fs.readFileSync("/proc/self/cgroup", "utf8").includes("docker");
		} catch {
			return false;
		}
	}
	#isCygwin() {
		try {
			return fs.existsSync("/cygdrive") || fs.existsSync("/proc/cygdrive");
		} catch {
			return false;
		}
	}
};
//#endregion
//#region src/node/providers/custom_slash_command_resolver.ts
let _initClass$3;
function _applyDecs$3(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$3(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$3(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$3(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$3(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$3(t) {
	var i = _toPrimitive$3(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$3(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$3(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$3(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const CustomSlashCommandResolver = createInterfaceId("CustomSlashCommandResolver");
const COMMANDS_DIR = "commands";
const COMMAND_NAME_REGEX$1 = /^[A-Za-z0-9][A-Za-z0-9_-]*$/;
const COMMAND_NAME_RULE$1 = "command names must start with a letter or number and contain only letters, numbers, hyphens, or underscores";
const MAX_DESCRIPTION_LENGTH$1 = 80;
const CommandFrontmatterSchema = z.object({ description: z.string() }).partial();
function isErrnoCode(error, code) {
	return typeof error === "object" && error !== null && "code" in error && error.code === code;
}
let _DefaultCustomSlashCo;
(class {
	static {
		[_DefaultCustomSlashCo, _initClass$3] = _applyDecs$3(this, [Injectable(CustomSlashCommandResolver, [Logger, ConfigService])], []).c;
	}
	#logger;
	#configService;
	#cache;
	constructor(logger, configService) {
		this.#logger = withPrefix(logger, "[CustomSlashCommandResolver]");
		this.#configService = configService;
	}
	async getCustomSlashCommands() {
		if (this.#cache) return this.#cache;
		const warnings = [];
		const files = await this.#findAllCommandFiles(warnings);
		const commands = await this.#readCommandFiles(files, warnings);
		this.#cache = {
			commands: this.#dedupe(commands),
			warnings
		};
		return this.#cache;
	}
	#dedupe(commands) {
		const unique = /* @__PURE__ */ new Map();
		for (const command of commands) {
			const existing = unique.get(command.name);
			if (!existing) unique.set(command.name, command);
			else if (command.source === "workspace" && existing.source === "global") {
				this.#logger.info(`Workspace custom command "${command.name}" overrides global command with the same name`);
				unique.set(command.name, command);
			} else this.#logger.debug(`Skipping duplicate custom command "${command.name}"`);
		}
		return [...unique.values()];
	}
	async #findAllCommandFiles(warnings) {
		const [workspaceFiles, globalFiles] = await Promise.all([this.#findWorkspaceCommandFiles(warnings), this.#findGlobalCommandFiles(warnings)]);
		return [...workspaceFiles, ...globalFiles];
	}
	async #findWorkspaceCommandFiles(warnings) {
		const dirs = (this.#configService.get().workspaceFolders || []).filter((wsf) => isFileSchemeUri(wsf.uri)).map((wsf) => join$1(parseURIString(wsf.uri).fsPath, ".agents", COMMANDS_DIR));
		return (await Promise.all(dirs.map((dir) => this.#findCommandsInDir(dir, "workspace", warnings)))).flat();
	}
	async #findGlobalCommandFiles(warnings) {
		const trustedDirs = getTrustedReadableDirectories().map((dir) => resolve(dir));
		const canonicalTrustedDirs = await Promise.all(trustedDirs.map(async (dir) => await this.#realPath(dir) || dir));
		const dirs = trustedDirs.map((dir) => join$1(dir, COMMANDS_DIR));
		return (await Promise.all(dirs.map((dir) => this.#findCommandsInDir(dir, "global", warnings, canonicalTrustedDirs)))).flat();
	}
	async #findCommandsInDir(dir, source, warnings, trustedRoots) {
		let entries;
		try {
			entries = await readdir(dir, { withFileTypes: true });
		} catch (error) {
			if (isErrnoCode(error, "ENOENT")) this.#logger.debug(`Custom commands directory not found: "${dir}"`);
			else {
				this.#logger.warn(`Could not read custom commands directory: "${dir}"`, error instanceof Error ? error : new Error(String(error)));
				warnings.push({
					path: dir,
					reason: "could not be read"
				});
			}
			return [];
		}
		return (await Promise.all(entries.filter((entry) => entry.name.endsWith(".md")).map((entry) => this.#resolveCommandEntry(dir, entry, warnings, trustedRoots)))).filter((entry) => entry !== void 0).map((entry) => ({
			entry,
			name: basename(entry.name, ".md")
		})).filter(({ entry, name }) => {
			if (COMMAND_NAME_REGEX$1.test(name)) return true;
			this.#logger.warn(`Skipping custom command file "${entry.name}" in "${dir}": invalid command name`);
			warnings.push({
				path: join$1(dir, entry.name),
				reason: `has an invalid command name — ${COMMAND_NAME_RULE$1}`
			});
			return false;
		}).map(({ entry, name }) => ({
			absolutePath: join$1(dir, entry.name),
			name,
			source
		}));
	}
	async #resolveCommandEntry(dir, entry, warnings, trustedRoots) {
		if (entry.isFile()) return entry;
		if (!entry.isSymbolicLink()) return void 0;
		const linkPath = join$1(dir, entry.name);
		let target;
		try {
			target = await stat(linkPath);
		} catch (error) {
			this.#logger.debug(`Could not read custom command symlink: "${linkPath}"`, error);
			return;
		}
		if (!target.isFile()) return void 0;
		if (trustedRoots) {
			const realPath = await this.#realPath(linkPath);
			if (!realPath || !isContainedIn(trustedRoots, realPath)) {
				this.#logger.warn(`Skipping custom command symlink "${linkPath}": target "${realPath}" is outside trusted directories`);
				warnings.push({
					path: linkPath,
					reason: "is a symlink whose target is outside the trusted directories"
				});
				return;
			}
		}
		return entry;
	}
	async #realPath(path) {
		try {
			return await realpath(path);
		} catch {
			return;
		}
	}
	async #readCommandFiles(files, warnings) {
		return (await Promise.all(files.map((file) => this.#tryReadCommandFile(file, warnings)))).filter((command) => command !== null);
	}
	async #tryReadCommandFile(file, warnings) {
		let raw;
		try {
			raw = await readFile(file.absolutePath, "utf8");
		} catch (error) {
			this.#logger.warn(`Could not read custom command file "${file.absolutePath}"`, error instanceof Error ? error : new Error(String(error)));
			warnings.push({
				path: file.absolutePath,
				reason: "could not be read"
			});
			return null;
		}
		const { frontmatter, body } = splitFrontmatter(raw);
		if (body.length === 0) {
			this.#logger.warn(`Skipping empty custom command file "${file.absolutePath}"`);
			warnings.push({
				path: file.absolutePath,
				reason: "has no content after the frontmatter"
			});
			return null;
		}
		return {
			name: file.name,
			description: this.#parseDescription(frontmatter, file.absolutePath, warnings),
			body,
			source: file.source
		};
	}
	#parseDescription(frontmatter, path, warnings) {
		if (frontmatter === void 0) return;
		let parsed;
		try {
			parsed = parse(frontmatter);
		} catch (error) {
			this.#logger.warn(`Could not parse frontmatter for custom command file "${path}"`, error instanceof Error ? error : new Error(String(error)));
			warnings.push({
				path,
				reason: "has invalid YAML frontmatter"
			});
			return;
		}
		const result = CommandFrontmatterSchema.safeParse(parsed);
		if (!result.success) {
			this.#logger.warn(`Custom command file "${path}" has an invalid "description" field`);
			warnings.push({
				path,
				reason: "has an invalid \"description\" field"
			});
			return;
		}
		if (!result.data.description) return;
		const desc = result.data.description;
		if (desc.length <= MAX_DESCRIPTION_LENGTH$1) return desc;
		return `${desc.slice(0, MAX_DESCRIPTION_LENGTH$1 - 1)}…`;
	}
	static {
		_initClass$3();
	}
});
//#endregion
//#region src/node/providers/noop_plugin_skills_source.ts
let _initClass$2;
function _applyDecs$2(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$2(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$2(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$2(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$2(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$2(t) {
	var i = _toPrimitive$2(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$2(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$2(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$2(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _NoopPluginSkillsSour;
(class {
	static {
		[_NoopPluginSkillsSour, _initClass$2] = _applyDecs$2(this, [Implements(PluginSkillsSource), Service({
			dependencies: [],
			lifetime: ServiceLifetime.Singleton
		})], []).c;
	}
	contributesSkills = false;
	async listSkillFiles() {
		return [];
	}
	static {
		_initClass$2();
	}
});
//#endregion
//#region src/node/providers/plugin_commands_source.ts
/** A command markdown file contributed by an installed plugin. */
/**
* Port for discovering slash-command files contributed by installed plugins.
* ai-context owns this interface but has no dependency on the plugin
* marketplace package; a client that has a marketplace (e.g. the CLI)
* registers that implementation, while other clients register
* `NoopPluginCommandsSource`.
*
* Implementations are responsible for path safety: returned
* `commandFilePath`s must already be confined to a location the
* implementation trusts (the plugin store).
*/
const PluginCommandsSource = createInterfaceId("AiContextPluginCommandsSource");
//#endregion
//#region src/node/providers/noop_plugin_commands_source.ts
let _initClass$1;
function _applyDecs$1(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$1(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$1(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$1(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$1(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$1(t) {
	var i = _toPrimitive$1(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$1(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$1(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _NoopPluginCommandsSo;
(class {
	static {
		[_NoopPluginCommandsSo, _initClass$1] = _applyDecs$1(this, [Implements(PluginCommandsSource), Service({
			dependencies: [],
			lifetime: ServiceLifetime.Singleton
		})], []).c;
	}
	contributesCommands = false;
	async listCommandFiles() {
		return [];
	}
	static {
		_initClass$1();
	}
});
//#endregion
//#region src/node/providers/plugin_slash_command_resolver.ts
let _initClass;
function _applyDecs(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey(t) {
	var i = _toPrimitive(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
/** A slash command contributed by an enabled, installed plugin. */
const PluginSlashCommandResolver = createInterfaceId("PluginSlashCommandResolver");
const COMMAND_NAME_REGEX = /^[A-Za-z0-9][A-Za-z0-9_-]*$/;
const COMMAND_NAME_RULE = "command names must start with a letter or number and contain only letters, numbers, hyphens, or underscores";
const MAX_DESCRIPTION_LENGTH = 80;
const PluginCommandFrontmatterSchema = z.object({
	description: z.string(),
	run: z.string().min(1),
	timeout: z.number().int().positive().max(600),
	interactive: z.boolean(),
	successExitCodes: z.array(z.number().int().min(0).max(255)).min(1),
	env: z.record(z.string(), z.string())
}).partial().superRefine((data, ctx) => {
	if (data.run !== void 0) return;
	const runDependentFields = {
		timeout: data.timeout !== void 0,
		interactive: Boolean(data.interactive),
		successExitCodes: data.successExitCodes !== void 0,
		env: data.env !== void 0 && Object.keys(data.env).length > 0
	};
	for (const [field, isSet] of Object.entries(runDependentFields)) if (isSet) ctx.addIssue({
		code: "custom",
		message: `only applies when "run" is set`,
		path: [field]
	});
});
/**
* Resolves slash commands contributed by installed plugins: lists command
* files via {@link PluginCommandsSource} and parses each markdown file's
* frontmatter (`description`, `run`, `timeout`) and body.
*
* Mirrors `DefaultCustomSlashCommandResolver`, but for plugin-provided
* commands. Name collisions across plugins resolve to the first command in
* plugin-id order; collisions with built-in/user commands are handled by the
* consumer (the slash command service registers plugin commands with the
* lowest priority).
*/
let _DefaultPluginSlashCo;
(class {
	static {
		[_DefaultPluginSlashCo, _initClass] = _applyDecs(this, [Implements(PluginSlashCommandResolver), Service({
			dependencies: [
				Logger,
				ConfigService,
				PluginCommandsSource
			],
			lifetime: ServiceLifetime.Singleton
		})], []).c;
	}
	#logger;
	#configService;
	#source;
	#cache;
	constructor(logger, configService, source) {
		this.#logger = withPrefix(logger, "[PluginSlashCommandResolver]");
		this.#configService = configService;
		this.#source = source;
	}
	async getPluginSlashCommands() {
		if (this.#cache) return this.#cache;
		if (!this.#source.contributesCommands) {
			this.#cache = {
				commands: [],
				warnings: []
			};
			return this.#cache;
		}
		let files;
		try {
			files = await this.#source.listCommandFiles(this.#workspacePaths());
		} catch (error) {
			this.#logger.warn("Could not list command files from the plugin commands source", error instanceof Error ? error : new Error(String(error)));
			return {
				commands: [],
				warnings: []
			};
		}
		const warnings = [];
		const commands = await this.#readCommandFiles(files, warnings);
		this.#cache = {
			commands: this.#dedupe(commands, warnings),
			warnings
		};
		return this.#cache;
	}
	#workspacePaths() {
		return (this.#configService.get().workspaceFolders || []).filter((wsf) => isFileSchemeUri(wsf.uri)).map((wsf) => parseURIString(wsf.uri).fsPath);
	}
	/**
	* Commands are keyed by `<pluginName>:<name>` — the canonical, namespaced
	* form consumers register — so two plugins contributing the same bare
	* command name both survive. Only a genuine duplicate (same plugin name and
	* command from two marketplaces) collides; first seen wins.
	*/
	#dedupe(commands, warnings) {
		const unique = /* @__PURE__ */ new Map();
		for (const command of commands) {
			const key = `${command.pluginName}:${command.name}`;
			const existing = unique.get(key);
			if (!existing) unique.set(key, command);
			else {
				this.#logger.warn(`Skipping plugin command "${key}" from ${command.pluginId}: already provided by ${existing.pluginId}`);
				warnings.push({
					path: command.displayPath,
					reason: `duplicates the command name "${key}" already provided by "${existing.displayPath}"`
				});
			}
		}
		return [...unique.values()];
	}
	async #readCommandFiles(files, warnings) {
		return (await Promise.all(files.map((file) => this.#tryReadCommandFile(file, warnings)))).filter((command) => command !== null);
	}
	async #tryReadCommandFile(file, warnings) {
		if (!COMMAND_NAME_REGEX.test(file.commandName)) {
			this.#logger.warn(`Skipping plugin command file "${file.commandFilePath}": invalid command name`);
			warnings.push({
				path: file.displayPath,
				reason: `has an invalid command name — ${COMMAND_NAME_RULE}`
			});
			return null;
		}
		let raw;
		try {
			raw = await readFile(file.commandFilePath, "utf8");
		} catch (error) {
			this.#logger.warn(`Could not read plugin command file "${file.commandFilePath}"`, error instanceof Error ? error : new Error(String(error)));
			warnings.push({
				path: file.displayPath,
				reason: "could not be read"
			});
			return null;
		}
		const { frontmatter, body } = splitFrontmatter(raw);
		if (body.length === 0) {
			this.#logger.warn(`Skipping empty plugin command file "${file.commandFilePath}"`);
			warnings.push({
				path: file.displayPath,
				reason: "has no content after the frontmatter"
			});
			return null;
		}
		const parsed = this.#parseFrontmatter(frontmatter, file, warnings);
		if (parsed === null) return null;
		return {
			name: file.commandName,
			description: this.#truncateDescription(parsed.description),
			body,
			run: parsed.run,
			timeoutSeconds: parsed.timeout,
			interactive: parsed.interactive,
			successExitCodes: parsed.successExitCodes,
			env: parsed.env,
			pluginId: file.pluginId,
			pluginName: file.pluginName,
			displayPath: file.displayPath
		};
	}
	#parseFrontmatter(frontmatter, file, warnings) {
		if (frontmatter === void 0) return {};
		let parsed;
		try {
			parsed = parse(frontmatter);
		} catch (error) {
			this.#logger.warn(`Could not parse frontmatter for plugin command file "${file.commandFilePath}"`, error instanceof Error ? error : new Error(String(error)));
			warnings.push({
				path: file.displayPath,
				reason: "has invalid YAML frontmatter"
			});
			return null;
		}
		const result = PluginCommandFrontmatterSchema.safeParse(parsed);
		if (!result.success) {
			const details = [...new Set(result.error.issues.map((issue) => {
				const field = issue.path.join(".");
				return field ? `${field} (${issue.message})` : issue.message;
			}))].join("; ");
			this.#logger.warn(`Plugin command file "${file.commandFilePath}" has invalid frontmatter: ${details}`);
			warnings.push({
				path: file.displayPath,
				reason: `has invalid frontmatter: ${details}`
			});
			return null;
		}
		return result.data;
	}
	#truncateDescription(description) {
		if (!description) return;
		if (description.length <= MAX_DESCRIPTION_LENGTH) return description;
		return `${description.slice(0, MAX_DESCRIPTION_LENGTH - 1)}…`;
	}
	static {
		_initClass();
	}
});
//#endregion
export { AgentSkillsResolver, AgentsMdResolver, BaseOSContextProvider, CustomSlashCommandResolver, _DefaultAgentSkillsRe as DefaultAgentSkillsResolver, _DefaultAgentsMdResol as DefaultAgentsMdResolver, _DefaultCustomSlashCo as DefaultCustomSlashCommandResolver, _DefaultOSContextProv as DefaultOSContextProvider, _DefaultPluginSlashCo as DefaultPluginSlashCommandResolver, _DefaultUserRuleConte as DefaultUserRuleContextProvider, _NoopPluginCommandsSo as NoopPluginCommandsSource, _NoopPluginSkillsSour as NoopPluginSkillsSource, PluginCommandsSource, PluginSkillsSource, PluginSlashCommandResolver, ShellDetector, buildShellContextItems, buildShellInfoContent, extractUnixShellName, formatShellEnvironment };

//# sourceMappingURL=node.mjs.map